// ** Third Party Imports
import styled from 'styled-components'

export const StepperContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	max-width: 90rem;
`

export const StepItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	position: relative;
`

interface StepCircleProps {
	$active: boolean
	$completed: boolean
}

export const StepCircle = styled.div<StepCircleProps>`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	font-weight: 600;
	transition: all 0.3s ease;
	
	${({ $active, $completed, theme }) => {
		if ($active) {
			return `
				background: transparent;
				color: #009689;
				border: 2px solid #009689;
			`
		} else if ($completed) {
			return `
				background: #009689;
				color: #009689;
				border: 2px solid #009689;
			`
		} else {
			return `
				background: ${theme.pallette.geniiWhite};
				color: ${theme.pallette.text.black50};
				border: 2px solid #d1d5dc;
			`
		}
	}}
`

interface StepLabelProps {
	$active: boolean
}

export const StepLabel = styled.span<StepLabelProps>`
	font-size: 14px;
	font-weight: 500;
	color: ${({ $active, theme }) =>
		$active ? theme.pallette.text.black : theme.pallette.text.black50};
	white-space: nowrap;
	transition: all 0.3s ease;
`

interface StepConnectorProps {
	$completed: boolean
}

export const StepConnector = styled.div<StepConnectorProps>`
	flex: 1;
	height: 2px;
	background: ${({ $completed }) =>
		$completed ? '#009689' : '#d1d5dc'};
	margin: 0 0.5rem;
	transition: all 0.3s ease;
	min-width: 40px;
`
